<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { ScaleTemplateViewerViewModel } from "@Scales/Components/ScaleTemplateViewer";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ScaleTemplateViewer extends Vue
    {
        get vm(): ScaleTemplateViewerViewModel { return this.$props.viewModel as ScaleTemplateViewerViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }
       
        get name(): string { return this.vm.name; }
        get description(): string { return this.vm.description; }
        get levels() { return this.vm.levels; }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{name}}</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p class="lead">{{description}}</p>
                        <p v-for="lvl in levels">
                            <strong>{{lvl.Value}} - {{lvl.Name}}</strong><br />
                            <span>{{lvl.Definition}}</span>
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>